import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { blogPosts } from '../../mocks/blogPosts';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

export default function BlogPost() {
  const location = useLocation();
  const slug = location.pathname.split('/blog/')[1];
  const post = blogPosts.find(p => p.slug === slug);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (post) {
      document.title = `${post.title} | ItsJustTax Blog`;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', post.excerpt);
      }
      
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', `${post.category}, tax guide, ${post.title.toLowerCase()}, IRS forms, tax filing`);
      }
    }
  }, [post]);

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Post Not Found</h1>
          <button 
            onClick={() => window.REACT_APP_NAVIGATE('/')}
            className="px-6 py-3 bg-teal-600 text-white rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      
      <article className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <button 
            onClick={() => window.REACT_APP_NAVIGATE('/')}
            className="flex items-center gap-2 text-teal-600 font-semibold mb-8 hover:gap-3 transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </button>

          <div className="mb-8">
            <span className="px-4 py-2 bg-teal-600 text-white rounded-full text-sm font-semibold whitespace-nowrap">
              {post.category}
            </span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {post.title}
          </h1>

          <div className="flex items-center gap-6 text-gray-600 mb-8">
            <div className="flex items-center gap-2">
              <i className="ri-user-line"></i>
              <span>{post.author}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-calendar-line"></i>
              <span>{post.date}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              <span>{post.readTime}</span>
            </div>
          </div>

          <div className="relative h-96 rounded-3xl overflow-hidden mb-12">
            <img 
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            <div dangerouslySetInnerHTML={{ __html: post.content }} />
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-2">Written by</p>
                <p className="text-lg font-bold text-gray-900">{post.author}</p>
              </div>
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="px-6 py-3 bg-teal-600 text-white rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
              >
                Read More Articles
              </button>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}